import { render } from "./administrative-other-count.vue?vue&type=template&id=265d3986&scoped=true"
import script from "./administrative-other-count.vue?vue&type=script&lang=js"
export * from "./administrative-other-count.vue?vue&type=script&lang=js"

import "./administrative-other-count.vue?vue&type=style&index=0&id=265d3986&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265d3986"]])

export default __exports__